/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Map = [
  "svg",
  defaultAttributes,
  [
    ["polygon", { points: "3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" }],
    ["line", { x1: "9", x2: "9", y1: "3", y2: "18" }],
    ["line", { x1: "15", x2: "15", y1: "6", y2: "21" }]
  ]
];

export { Map as default };
//# sourceMappingURL=map.js.map
